import { render, staticRenderFns } from "./formdialog.vue?vue&type=template&id=7b3d19d6"
import script from "./formdialog.vue?vue&type=script&lang=js"
export * from "./formdialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports